import type { CatalogResource } from '../../types.js';
import { FEATURE_GROUP_KEYS } from '../feature-groups.js';
import { ROLE_KEYS } from '../roles.js';

const GROUP = FEATURE_GROUP_KEYS.PRODUCTS;
const defaultGrants = {
  [ROLE_KEYS.COMPANY_ADMIN]: 'all',
  [ROLE_KEYS.COMPANY_CREATOR]: 'all',
  [ROLE_KEYS.COMPANY_READER]: ['read'],
} as const;

export const products = [
  {
    key: 'styles',
    name: 'Styles',
    description: 'Style and article master data',
    group: GROUP,
    actions: ['read', 'create', 'edit', 'delete', 'archive'],
    grants: defaultGrants,
  },
  {
    key: 'digital-products-passport',
    name: 'Digital Products Passport',
    description: 'Consumer-facing product passports',
    group: GROUP,
    actions: ['create', 'read', 'edit', 'archive'],
    grants: defaultGrants,
  },
  {
    key: 'fiber-forward',
    name: 'Fiber Forward',
    description: 'Fiber-level sourcing programme',
    group: GROUP,
    actions: ['create', 'read', 'edit', 'archive'],
    grants: defaultGrants,
  },
] as const satisfies readonly CatalogResource[];
